import { create } from 'zustand';

export const useConfigStore = create((set) => ({
  apiUrl: '',
  setApiUrl: (url) => set({ apiUrl: url }),
}));
